export const advantages = [
  { value: '5+', label: 'Years on the market' },
  { value: '30+', label: 'People in the team' },
  { value: '100TB+', label: 'Of data, used to create models' },
  { value: '1B+', label: 'Trades executed through our trading platform' },
];
